module.exports = __webpack_public_path__ + "f60761f80bb1012a42f731c65dc5fd4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/gilles-harmonica.png
// module id = 3011
// module chunks = 0